import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import "./ClientsSection.scss";

function ClientsSection(props) {
  const items = [
    {
      name: "Ethereum",
      image: "ethereum-logo.svg",
      width: "150px",
    },
    {
      name: "Flow",
      image: "flow-logo.svg",
      width: "100px",
    },
    {
      name: "Polygon",
      image: "polygon-logo.svg",
      width: "150px",
    },
  ];

  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={3}
          spaced={true}
          className="has-text-centered"
        />
        <div className="columns is-centered is-multiline pb-3">
          {items.map((item, index) => (
            <div className="column is-narrow has-text-centered" key={index}>
              <div className="ClientsSection__logo">
                <img src={item.image} width={item.width} alt={item.name} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}

export default ClientsSection;
